import { graphql } from 'src/gql'
import { SortFindManyStaffingAgencyClearedFacilityInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQLDropdownOptions } from 'src/queries/cat/lookups/helpers'

const document = graphql(/* graphql */`
  query staffingAgencyClearedFacilities($sort: SortFindManyStaffingAgencyClearedFacilityInput) {
    lookups {
      StaffingAgencyClearedFacility {
        many(sort: $sort) {
          _id
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyClearedFacilities = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['StaffingAgencyClearedFacility']>['many']>

const useStaffingAgencyClearedFacilities = useGraphQLDropdownOptions(
  document,
  'lookups.StaffingAgencyClearedFacility.many',
  {
    sort: SortFindManyStaffingAgencyClearedFacilityInput.OrderAsc
  }
)

export { useStaffingAgencyClearedFacilities, document as staffingAgencyClearedFacilitiesDocument }
